import {
  ExtractFnReturnType,
  InfiniteQueryConfigType,
  useInfiniteQuery,
  UseInfiniteQueryResult,
} from "~/libs";

import { ApiClient } from "~/utils";

import { ApisMembersAnalysisInsightPostObjectivesIndexResponseTypes } from "~/domains";

type RequestDataType = {
  page?: number;
};

const request = async ({
  page = 1,
}: RequestDataType): Promise<ApisMembersAnalysisInsightPostObjectivesIndexResponseTypes> => {
  const response =
    await new ApiClient().get<ApisMembersAnalysisInsightPostObjectivesIndexResponseTypes>(
      "/api/members/analysis/insight_post_objectives",
      { page },
    );
  return response.data;
};

type QueryFnType = typeof request;

type PropsType = {
  config?: InfiniteQueryConfigType<QueryFnType>;
};

export const useApisMembersAnalysisInsightPostObjectivesIndex = ({
  config = {},
}: PropsType = {}): UseInfiniteQueryResult<ApisMembersAnalysisInsightPostObjectivesIndexResponseTypes> => {
  return useInfiniteQuery<ExtractFnReturnType<QueryFnType>>(
    ["ApisMembersAnalysisInsightPostObjectivesIndex"],
    ({ pageParam }) => {
      return request({ page: pageParam as number | undefined });
    },
    {
      ...config,
      getNextPageParam: (data) => {
        return data.pagy.hasMore ? data.pagy.currentPage + 1 : false;
      },
    },
  );
};
